import React from "react";

const Loading = () => {
  return (
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Carregando...</span>
    </div>
  );
};
export default Loading;
